<template>
  <div class="card-form">
    <page-main ref="main"> </page-main>
  </div>
</template>
<script>
import PageMain from './main'
import BaseTable from '@/mixins/base-table'

export default {
  data() {
    return {
      tableData: {}
    }
  },
  components: {
    PageMain
  },
  mixins: [BaseTable],

  methods: {}
}
</script>
